import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { Ochannel } from '../../models/promotion-ochannel.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { URLSearchParams } from '@angular/http';


@Injectable()
export class PromotionOchannelService {

  public baseUrl = '/koncentro-promo';

  constructor(
    private http: HttpClientService
  ) { }

  get(oChannelId): Observable<Ochannel> {
    return this.http.get(this.baseUrl + '/ochannel/' + oChannelId);
  }

  list(offset = null, limit = null, search?: Array<{ key: string, value: string }>): Observable <{data: Array<Ochannel>, metadata: ListMetadata}> {
    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }

    if ( offset !== null ) {
      params.set('offset', offset.toString());
    }
    if ( limit !== null ) {
      params.set('limit', limit.toString());
    }

    return this.http.get(this.baseUrl + '/ochannel?' + params.toString());
  }

  
  update(oChannel: Ochannel): Observable<Ochannel> {
    return this.http.put(this.baseUrl + '/ochannel/' + oChannel.id, oChannel);
  }

  create(oChannel: Ochannel): Observable<Ochannel> {
    return this.http.post(this.baseUrl + '/ochannel/' , oChannel );
  }

  remove(oChannelId): Observable<Ochannel> {
    return this.http.delete(this.baseUrl + '/ochannel/' + oChannelId);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-ochannel.service.ts